let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dqDrJ")).then(() => parcelRequire('4uxmF'));